/* tslint:disable */
/* eslint-disable */
/**
 * Notes API
 * API for managing notes with tags, mentions and attachments
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateNoteCommand,
  CreateTagNoteCommand,
  ErrorResponse,
  GetGenericListCommandDto,
  GetListeNotesResponse,
  GetNoteResponse,
  OperationResponse,
  SearchTagsNotesCommand,
  SearchTagsNotesResponse,
  UpdateNoteCommand,
} from '../models/index';
import {
    CreateNoteCommandFromJSON,
    CreateNoteCommandToJSON,
    CreateTagNoteCommandFromJSON,
    CreateTagNoteCommandToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetGenericListCommandDtoFromJSON,
    GetGenericListCommandDtoToJSON,
    GetListeNotesResponseFromJSON,
    GetListeNotesResponseToJSON,
    GetNoteResponseFromJSON,
    GetNoteResponseToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    SearchTagsNotesCommandFromJSON,
    SearchTagsNotesCommandToJSON,
    SearchTagsNotesResponseFromJSON,
    SearchTagsNotesResponseToJSON,
    UpdateNoteCommandFromJSON,
    UpdateNoteCommandToJSON,
} from '../models/index';

export interface CreateNoteAsyncRequest {
    createNoteCommand: CreateNoteCommand;
}

export interface CreateTagAsyncRequest {
    createTagNoteCommand: CreateTagNoteCommand;
}

export interface DeleteNoteAsyncRequest {
    noteId: string;
}

export interface DeleteTagAsyncRequest {
    tagId: string;
}

export interface GetListeNotesAsyncRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetNoteAsyncRequest {
    noteId: string;
}

export interface SearchTagsAsyncRequest {
    searchTagsNotesCommand: SearchTagsNotesCommand;
}

export interface UpdateNoteAsyncRequest {
    noteId: string;
    updateNoteCommand: UpdateNoteCommand;
}

/**
 * 
 */
export class NotesApi extends runtime.BaseAPI {

    /**
     * Creates a new note with optional tags, mentions and attachments
     * Create a new note
     */
    async createNoteAsyncRaw(requestParameters: CreateNoteAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createNoteCommand'] == null) {
            throw new runtime.RequiredError(
                'createNoteCommand',
                'Required parameter "createNoteCommand" was null or undefined when calling createNoteAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/notes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateNoteCommandToJSON(requestParameters['createNoteCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new note with optional tags, mentions and attachments
     * Create a new note
     */
    async createNoteAsync(requestParameters: CreateNoteAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createNoteAsyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new custom tag for the broker
     * Create a new custom tag
     */
    async createTagAsyncRaw(requestParameters: CreateTagAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createTagNoteCommand'] == null) {
            throw new runtime.RequiredError(
                'createTagNoteCommand',
                'Required parameter "createTagNoteCommand" was null or undefined when calling createTagAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/notes/tags`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTagNoteCommandToJSON(requestParameters['createTagNoteCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new custom tag for the broker
     * Create a new custom tag
     */
    async createTagAsync(requestParameters: CreateTagAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createTagAsyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a note by its ID
     * Delete a note
     */
    async deleteNoteAsyncRaw(requestParameters: DeleteNoteAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling deleteNoteAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/notes/{noteId}`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Deletes a note by its ID
     * Delete a note
     */
    async deleteNoteAsync(requestParameters: DeleteNoteAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteNoteAsyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permanently deletes a custom tag (non-global). This will remove the tag from all notes.
     * Delete a custom tag
     */
    async deleteTagAsyncRaw(requestParameters: DeleteTagAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tagId'] == null) {
            throw new runtime.RequiredError(
                'tagId',
                'Required parameter "tagId" was null or undefined when calling deleteTagAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/notes/tags/{tagId}`.replace(`{${"tagId"}}`, encodeURIComponent(String(requestParameters['tagId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Permanently deletes a custom tag (non-global). This will remove the tag from all notes.
     * Delete a custom tag
     */
    async deleteTagAsync(requestParameters: DeleteTagAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteTagAsyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a paginated list of notes for the connected broker
     * Get list of notes
     */
    async getListeNotesAsyncRaw(requestParameters: GetListeNotesAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetListeNotesResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getListeNotesAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/notes/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetListeNotesResponseFromJSON(jsonValue));
    }

    /**
     * Returns a paginated list of notes for the connected broker
     * Get list of notes
     */
    async getListeNotesAsync(requestParameters: GetListeNotesAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetListeNotesResponse> {
        const response = await this.getListeNotesAsyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the full details of a specific note
     * Get note by ID
     */
    async getNoteAsyncRaw(requestParameters: GetNoteAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNoteResponse>> {
        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling getNoteAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/notes/{noteId}`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNoteResponseFromJSON(jsonValue));
    }

    /**
     * Returns the full details of a specific note
     * Get note by ID
     */
    async getNoteAsync(requestParameters: GetNoteAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNoteResponse> {
        const response = await this.getNoteAsyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for available tags (global + custom) for the broker
     * Search tags
     */
    async searchTagsAsyncRaw(requestParameters: SearchTagsAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchTagsNotesResponse>> {
        if (requestParameters['searchTagsNotesCommand'] == null) {
            throw new runtime.RequiredError(
                'searchTagsNotesCommand',
                'Required parameter "searchTagsNotesCommand" was null or undefined when calling searchTagsAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/notes/tags/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchTagsNotesCommandToJSON(requestParameters['searchTagsNotesCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchTagsNotesResponseFromJSON(jsonValue));
    }

    /**
     * Search for available tags (global + custom) for the broker
     * Search tags
     */
    async searchTagsAsync(requestParameters: SearchTagsAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchTagsNotesResponse> {
        const response = await this.searchTagsAsyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing note with new values
     * Update a note
     */
    async updateNoteAsyncRaw(requestParameters: UpdateNoteAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling updateNoteAsync().'
            );
        }

        if (requestParameters['updateNoteCommand'] == null) {
            throw new runtime.RequiredError(
                'updateNoteCommand',
                'Required parameter "updateNoteCommand" was null or undefined when calling updateNoteAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/notes/{noteId}`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateNoteCommandToJSON(requestParameters['updateNoteCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Updates an existing note with new values
     * Update a note
     */
    async updateNoteAsync(requestParameters: UpdateNoteAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateNoteAsyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
